module.exports = __webpack_public_path__ + "images/grupo_IDCharge.b361d13f.png";